"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Portal = void 0;

var ReactDOM = require("react-dom");

exports.Portal = function (_a) {
  var children = _a.children,
      _b = _a.container,
      container = _b === void 0 ? 'body' : _b;
  return ReactDOM.createPortal(children, document.querySelector(container));
};